<script>
// import axios from "axios";
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import axios from "axios";
import Fields from "@/helpers/fields";
import Vue from 'vue';
import VueSweetalert2 from 'vue-sweetalert2';
// If you don't need the styles, do not connect
import 'sweetalert2/dist/sweetalert2.min.css';
Vue.use(VueSweetalert2);

import { todoMethods, todoComputed } from "@/state/helpers";

import { tableData } from "../dataAdvancedtable";

/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Puntos de entrega",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      // ************************************** Link
      tableData: tableData,
      title: "Puntos de entrega",
      items: [
        {
          text: "Escritorio",
          href: "/",
        },
        {
          text: "Puntos de entrega",
          active: true,
        },
      ],
      statData: [
        {
          icon: "bx bx-copy-alt",
          title: "Orders",
          value: "1,235",
        },
        {
          icon: "bx bx-archive-in",
          title: "Revenue",
          value: "$35, 723",
        },
        {
          icon: "bx bx-purchase-tag-alt",
          title: "Average Price",
          value: "$16.2",
        },
      ],
      tableDeliveryPoints: [],
      showModal: false,
      isLoading: false,
      fullPage: true,
      canCancel: false,
      totalRows: 1,
      todoTotalRows: 1,
      currentPage: 1,
      todocurrentPage: 1,
      perPage: 10,
      todoperPage: 10,
      pageOptions: [10, 25, 50, 100],
      todoOptions: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortBy: "age",
      sortDesc: false,
      useSlot: false,
      loader: "spinner",
      color: "#007bff",
      bgColor: "#FFFFFF",
      height: 128,
      width: 128,
      timeout: 3000, //ms
      fetchingStats: true,
      earningStatus: true,
      puntosentregaFields: Fields.puntosentregaFields,
    };
  },

  computed: {
    ...todoComputed,
    /**
     * Total no. of records
     */
    rows() {
      return this.tableData.length;
    },

    /**
     * Todo list of records
     */
    todoList() {
      return this.todos.length;
    },
  },

  mounted() {
    this.getTable();

    this.fetchTodos();
    // Set the initial number of items
    this.totalRows = this.tableData.length;

    this.todoTotalRows = this.todos.length;

    document.getElementById("b_table_delivery").firstElementChild.classList.add("table-light");
  },

  methods: {
    getTable() {
      axios.get("/puntos_entrega").then((response) => {
        this.response = response.data.data;
        this.tableDeliveryPoints = response.data.data;
        console.log(response);
      });
    },
    ...todoMethods,

    handleEdit(id_punto_entrega){
     this.$router.push(
       {
         name:'ActualizaPEntrega',
         params:{
           id_punto_entrega
         }
       })
    },

    handleDelete(id_punto_entrega) {
      this.$swal({
        title: "¿Estas seguro de borrar?",
        text: "",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, borrar",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.isConfirmed) {
          axios
            .put(
              "/puntos_entrega",
              { id_punto_entrega: id_punto_entrega, active: "0" }
            )
            .then((res) => {
              const { response = "" } = res.data;
              if (response === true) {
                this.$swal(
                  "Eliminado",
                  "Punto de entrega eliminado",
                  "success"
                );
                this.getTable();
              } else {
                this.$swal("Alerta!", "No se pudo eliminar", "warning");
              }
            })
            .catch((error) => {
              this.errorMessage = error.message;
              console.log(error);
              this.$swal("Error!", "Ocurrio un error", "danger");
            });
        }
      });
    },
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    todoFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.todoTotalRows = filteredItems.length;
      this.todocurrentPage = 1;
    },

    getColor(estado) {
      if (estado == "Activo") return "red";
      else return "green";
    },

    handleInput(value, data) {
      this.editableDataItems[data.index][data.field.key] = value;
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <!-- end row -->
    <div class="row mb-6">
      <div class="col-lg-12">
        <v-card>
          <div class="card-body">
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <h4 class="card-title mb-4">Puntos de entrega</h4>
              </div>
              <div class="col-sm-12 col-md-6 text-md-end">
                <router-link to="/NuevoPuntoEntrega">
                  <v-btn
                    depressed
                    color="primary"
                    type="button"
                    id="button-addon2"
                  >
                    Nuevo registro
                  </v-btn>
                </router-link>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Ver
                    <v-divider class="mx-1" inset vertical></v-divider>
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select>
                    <v-divider class="mx-1" inset vertical></v-divider>

                    registros
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Buscar:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Buscar..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- tableDeliveryPoints table -->
            <b-table
              id="b_table_delivery"
              :fields="puntosentregaFields"
              :items="tableDeliveryPoints"
              :filter="filter"
              :current-page="currentPage"
              :per-page="perPage"
            >
              <template #cell(id_punto_entrega)="data">
                <a href="javascript: void(0);" class="text-body fw-bold">
                  {{ data.item.id_punto_entrega }}
                </a>
              </template>
              <template #cell(tipo)="data">
                <span
                  class="badge rounded-pill bg-primary font-size-11"
                  :class="{
                    'bg-warning': `${data.item.tipo}` === 'Empresa',
                    'bg-warning': `${data.item.tipo}` === 'Diferente',
                  }"
                  >{{ data.item.tipo }}</span
                >
              </template>
              <template #cell(estatus)="data">
                <span
                  class="badge rounded-pill bg-success font-size-11"
                  :class="{
                    'bg-warning': `${data.item.estatus}` === '0',
                    'bg-success': `${data.item.estatus}` === '1',
                  }"
                  >{{ data.item.estatus === 1 ? "Activo" : "Desactivo" }}</span
                >
              </template>
              <template #cell(edit)="data">
                <div class="row">
                  <div class="col-sm-1">
                    <button
                      type="button"
                      class="btn-sm btn-rounded botontabla"
                      @click="handleEdit(data.item.id_punto_entrega)"
                    >
                      <i style="color: #09a5c7" class="bx bxs-pencil"></i>
                    </button>
                  </div>
                  <div class="col-sm-1">
                    <button
                      type="button"
                      class="btn-sm btn-rounded botontabla"
                      @click="handleDelete(data.item.id_punto_entrega)"
                    >
                      <i style="color: #e73484" class="bx bx-trash"></i>
                    </button>
                  </div>
                </div>
              </template>
            </b-table>
          </div>
          <div class="row mt-4">
            <div class="col-sm-12 col-md-6">
              <v-divider class="mx-2" inset vertical></v-divider>
              Mostrando {{ perPage > tableDeliveryPoints.length ? tableDeliveryPoints.length : perPage }} de {{ tableDeliveryPoints.length }} registros
            </div>
            <div class="col-sm-12 col-md-6 text-md-end pr-10">
              <b-pagination
                align="right"
                v-model="currentPage"
                :total-rows="tableDeliveryPoints.length"
                :per-page="perPage"
                first-text="Primera"
                prev-text="Anterior"
                next-text="Siguiente"
                last-text="Última"
              ></b-pagination>
            </div>
          </div>
        </v-card>
      </div>
    </div>
  </Layout>
</template>
